import { all } from 'redux-saga/effects';
import taskSagas from './tasks';
import materialSagas from './materials';
import labourSagas from './labours';
import defectSagas from './defects';
import taskHistorySagas from './taskHistory';
import productHistorySagas from './productHistory';
import warehouseProductSagas from './warehouseProduct'

export default function* rootSaga() {
  yield all([
    ...taskSagas,
    ...materialSagas,
    ...labourSagas,
    ...defectSagas,
    ...taskHistorySagas,
    ...productHistorySagas,
    ...warehouseProductSagas,
  ]);
}
